import { render, staticRenderFns } from "./AdminVipGroupCreateForm.vue?vue&type=template&id=2dd260d9&"
import script from "./AdminVipGroupCreateForm.vue?vue&type=script&lang=ts&"
export * from "./AdminVipGroupCreateForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QForm from 'quasar/src/components/form/QForm.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QForm,QSeparator});
